import React from "react";
import { Card, Button } from "../../../../common";
import WorkingRelation from "../../../../../assets/images/working-relation.png";
import { RegisterNow } from "./RegisterNow";
import { ReactComponent as MarMarker } from "../../../../../assets/icons/addressIcons/address1.svg";
import { ReactComponent as EmailIcon } from "../../../../../assets/icons/addressIcons/email.svg";
import { ReactComponent as PhoneIcon } from "../../../../../assets/icons/addressIcons/phone.svg";
import { ReactComponent as HoursIcon } from "../../../../../assets/icons/addressIcons/hours.svg";
import { ReactComponent as OkIcon } from "../../../../../assets/icons/ok-icon.svg";
import { ReactComponent as EndorsementIcon } from '../../../../../assets/endorseBanner/building-endorsement-icon.svg';
import { ReactComponent as GrayHelp } from '../../../../../assets/endorseBanner/help-icon-gray.svg';
import { ReactComponent as Rocket } from "../../../../../assets/images/rocket.svg";
import { GetTheCompany } from "../../../../common";
import { Address } from "./Address";
import { getStateNameFromGeoNameId } from "../../../../../utils/Helper";
import { formatDateWithOrdinal } from "../../../../../global_functions/global";
import { useSelector } from "react-redux";
import useScreenSize from "../../../../../Hooks/useScreenSize";
import { useEffect } from "react";
import CommonTooltip from "../../../../common/Tooltip";
import { useParams } from "react-router-dom";
import HelpIcon from "../../../../../assets/endorseBanner/HelpIcon";

export const GeneralInfo = ({ company, trevexId, SubscriptionActive, purchaseSubScriptionValid, handlePurchased, createWorldBoxOrder, handleGetCompany }) => {
  const { userInfo, isLoggedIn, token } = useSelector((state) => state.auth);
  const { id } = useParams();
  const arr1 = userInfo?.individual[0]?.individual || [];
  const companyArr = arr1.map((company) => company?.companyID?.companyID);
  const { isMobile, isTablet, isDesktop } = useScreenSize();

  let sec_list_company = {
    state: "State Name",
    city: "City Name",
    postcode: "2185223",
    address_line_1: "Dubai, United Arab Emirates",
    email: "info@secondarycomp.com",
    phone: "+971552315526",
    telephone: "+97142358669",
    working_hours: "9 AM to 5 PM",
    company_description: ""
  }
  const companyInfo = arr1.find(company => company.companyID?.companyID === id);
  const role = companyInfo ? companyInfo.role : undefined;

  const companyType = company?.companyID === undefined
    ? "listing"
    : company?.verifiedCompany != null
      ? "verified"
      : (company?.claimed && "claimed") ||
      (company?.draft && "warning")

  const status = company?.companyID === undefined
    ? "listing"
    : company?.verifiedCompany != null
      ? "verified"
      : (company?.claimed && "claimed") ||
      (company?.draft && "warning")


  return (
    <>
      {
        ((company?.claimed === true || purchaseSubScriptionValid)) ?
          <div className="grid md:grid-cols-5 grid-cols-4 gap-6">
            <div className="grid gap-4 md:col-span-2 col-span-4 order-last md:order-first">
              {company?.sub_industry_data?.length > 0 && <Card classes="bg-white px-8 py-8 rounded-xl">
                <p className="font-semibold text-[#012234] text-[18px] sm:text-f18 text-left">Industry</p>
                <ul className="last-child:border-b-transparent">
                  {/* <Rocket className="sm:w-auto w-16" /> */}

                  {company?.sub_industry_data?.map((industry) => <li key={industry.id} className="flex items-center justify-start gap-3 sm:gap-4 text-secondary text-f12 py-3 border-b border-Slate test">
                    <Rocket />
                    <div className="flex flex-col text-left">
                      <span className="text-primary text-f14">{industry.sub_industry}</span>
                    </div>
                  </li>)}
                </ul>
              </Card>}
              <Card classes="bg-white px-8 py-8 rounded-xl">
                <p className="font-semibold text-[#012234] text-[18px] sm:text-f18 text-left">Address</p>
                <ul className="last-child:border-b-transparent">
                  {trevexId
                    ? company?.companyAddress[0]?.company_address_detailsID
                      ?.state && (

                      <Address
                        Icon={MarMarker}
                        info1="State"
                        info2={
                          company?.companyAddress[0]?.company_address_detailsID
                            ?.state
                        }
                      />
                    )
                    : company?.company?.city && (
                      <Address
                        Icon={MarMarker}
                        info1="State"
                        info2={company?.company?.city}
                      />
                    )}
                  {trevexId ? (
                    company?.companyAddress[0]?.company_address_detailsID?.city && (
                      <Address
                        Icon={MarMarker}
                        info1="City"
                        info2={
                          company?.companyAddress[0]?.company_address_detailsID?.city
                        }
                      />
                    )
                  ) : (
                    <Address
                      Icon={MarMarker}
                      info1="City"
                      info2={company?.company?.city}
                    />
                  )}
                  {trevexId && (
                    company?.companyAddress[0]?.company_address_detailsID?.area && (
                      <Address
                        Icon={MarMarker}
                        info1="Area"
                        info2={
                          company?.companyAddress[0]?.company_address_detailsID?.area
                        }
                      />
                    )
                  )}
                  {trevexId
                    ? company?.companyAddress[0]?.company_address_detailsID
                      ?.postal_code && (
                      <Address
                        Icon={MarMarker}
                        info1="ZIP Code"
                        info2={
                          company?.companyAddress[0]?.company_address_detailsID
                            ?.postal_code
                        }
                      />
                    )
                    : company?.company?.postcode !== "" && (
                      <Address
                        Icon={MarMarker}
                        info1="ZIP Code"
                        info2={company?.company?.postcode}
                      />
                    )}

                  {trevexId && company?.companyAddress[0]?.company_address_detailsID?.address_line_1 && (
                    <Address
                      Icon={MarMarker}
                      info1="Address Line 1"
                      info2={
                        company?.companyAddress[0]?.company_address_detailsID
                          ?.address_line_1
                      }
                    />
                  )}
                  {trevexId &&
                    company?.companyAddress[0]?.company_address_detailsID?.email && (
                      <Address
                        Icon={EmailIcon}
                        info1="Email Address"
                        info2={
                          company?.companyAddress[0]?.company_address_detailsID?.email
                        }
                      />
                    )}
                  {trevexId &&
                    company?.companyAddress[0]?.company_address_detailsID?.phone && (
                      <Address
                        Icon={PhoneIcon}
                        info1="Mobile number"
                        info2={
                          company?.companyAddress[0]?.company_address_detailsID?.phone
                        }
                      />
                    )}
                  {trevexId &&
                    company?.companyAddress[0]?.company_address_detailsID?.telephone && (
                      <Address
                        Icon={PhoneIcon}
                        info1="Telephone"
                        info2={
                          (company?.companyAddress[0]?.company_address_detailsID?.telephone?.replace(/\|/g, "")).replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')
                        }
                      />
                    )}
                  {trevexId &&
                    company?.companyAddress[0]?.company_address_detailsID
                      ?.working_hours && (
                      <Address
                        Icon={HoursIcon}
                        info1="Working Hours"
                        info2={
                          company?.companyAddress[0]?.company_address_detailsID
                            ?.working_hours
                        }
                      />
                    )}
                </ul>
              </Card>
            </div>
            <div className="md:col-span-3 col-span-4 order-first md:order-last">

              {company?.company_description && (
                <Card classes="p-6 text-left bg-white rounded-xl">
                  <div className="flex justify-between items-center pb-3">
                    <h2 className="w-[302px] text-primary text-[18px] sm:text-f18 font-semibold">
                      About Business
                    </h2>
                    {/* TIP-504 — endorsement summary moved to the always-visible
                        profile banner (BannerCompanyCard / EndorsementBanner),
                        gated by the viewer's active-company membership. */}
                  </div>
                  <p className="text-left text-secondary text-[14px] sm:text-f16" dangerouslySetInnerHTML={{ __html: company?.company_description }}>
                  </p>
                </Card>
              )}

              <Card classes="hidden mt-4 p-6 bg-blue text-left rounded-xl">
                <div className="flex items-center justify-center align-middle">
                  <div>
                    <h2 className="text-white text-f24 pb-3">Add Working Relation</h2>
                    <p className="text-left text-white text-f16 mb-2">
                      Stay update with all the changes happening in a business
                    </p>
                    <Button classes="bg-white rounded-full py-2 px-8 text-blue mb-auto">
                      Add now
                    </Button>
                  </div>
                  <div className="ml-auto">
                    <img src={WorkingRelation} alt="working relation" />
                  </div>
                </div>
              </Card>
              <div className="pb-0 pt-4 sm:py-4">
                <RegisterNow />
              </div>

            </div>
          </div>
          :
          (status === "warning" || status === "listing") ?
            <div className="relative">
              <div className={`${isMobile ? "h-[364px]" : "blur"} grid md:grid-cols-5 grid-cols-4 gap-6`}>
                <div className={`${isMobile && "hidden"} md:col-span-2 col-span-4 order-last md:order-first`}>
                  <Card classes="bg-white px-8 py-8 rounded-xl">
                    <ul className="last-child:border-b-transparent">
                      <Address
                        Icon={MarMarker}
                        info1="State"
                        info2={sec_list_company.state}
                      />
                      <Address
                        Icon={MarMarker}
                        info1="City"
                        info2={sec_list_company.city}
                      />
                      <Address
                        Icon={MarMarker}
                        info1="ZIP Code"
                        info2={sec_list_company.postcode}
                      />

                      <Address
                        Icon={MarMarker}
                        info1="Address Line 1"
                        info2={sec_list_company.address_line_1}
                      />


                    </ul>
                    <Button classes="bg-white rounded w-full py-3 px-8 text-link font-semibold mb-auto border border-link mt-4">
                      Get in touch
                    </Button>
                  </Card>
                </div>
                <div className="md:col-span-3 col-span-4 order-first md:order-last">


                  {sec_list_company.company_description && <Card classes="p-6 text-left bg-white rounded-xl">
                    <h2 className="text-primary text-[13px] sm:text-f24 font-semibold pb-3">
                      About Business
                    </h2>
                    <p className="text-left text-secondary text-[14px] sm:text-f16">
                      {sec_list_company.company_description}
                    </p>
                  </Card>}

                  <Card classes="hidden mt-4 p-6 bg-blue text-left rounded-xl">
                    <div className="flex items-center justify-center align-middle">
                      <div>
                        <h2 className="text-white text-f24 pb-3">Add Working Relation</h2>
                        <p className="text-left text-white text-f16 mb-2">
                          Stay update with all the changes happening in a business
                        </p>
                        <Button classes="bg-white rounded-full py-2 px-8 text-blue mb-auto">
                          Add now
                        </Button>
                      </div>
                      <div className="ml-auto">
                        <img src={WorkingRelation} alt="working relation" />
                      </div>
                    </div>
                  </Card>
                  <div className="py-4">
                    <RegisterNow />
                  </div>

                </div>
              </div>
              {<div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-white rounded-lg shadow-lg p-4 w-[450px]">
                  <GetTheCompany
                    handleGetCompany={handleGetCompany}
                    createWorldBoxOrder={createWorldBoxOrder}
                    company_id={company?.companyID}
                    company={company}
                    SubscriptionActive={SubscriptionActive}
                    handlePurchased={createWorldBoxOrder}
                    des={
                      " Request to get the business information and TREVEX will do that for you."
                    }
                    button={"Get Details"}
                  />
                </div>
              </div>}
            </div>
            :
            null
      }

    </>
  );
};
